<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">Your Classes</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <div class="ui ordered steps">
        <div class="active step">
          <div class="content">
            <div class="title">Class selection</div>
            <div class="description">Select or Add class</div>
          </div>
        </div>
        <div class="step">
          <div class="content">
            <div class="title">Student selection</div>
            <div class="description">
              Check the list of Students and make changes if required
            </div>
          </div>
        </div>
        <div class="step">
          <div class="content">
            <div class="title">Confirm</div>
            <div class="description">Verify and Proceed</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui divider"></div>
    <div class="row right floated">
      <div class="right floated right aligned size wide column">
        <span>Search for class: <input v-model="filter" type="text" /></span>
      </div>
    </div>
    <div class="ui message error" v-if="classesError">{{ classesError }}</div>
    <div class="row">
      <class-table
        v-bind:classes="classesFiltered || classes"
        v-bind:actions="classActions"
        v-on:rowAction="classSelected"
      />
    </div>
    <sui-button
      content="Add class"
      positive
      icon="plus"
      v-on:click="showCreateModal"
    >
    </sui-button>
  </div>
</template>

<script>
import ClassTable from '@/components/classes/ClassTable';
import { mapGetters } from 'vuex';

export default {
  name: 'ClassSelection',
  components: { ClassTable },
  computed: {
    ...mapGetters({
      classes: 'classes',
      classesError: 'classesError',
    }),
  },
  data() {
    return {
      classActions: ['select', 'remove'],
      filter: '',
      classesFiltered: null,
    };
  },
  watch: {
    filter(val) {
      if (this.filter.length > 0) {
        // eslint-disable-next-line arrow-parens
        this.classesFiltered = this.classes.filter((item) =>
          item.name.toLowerCase().includes(val.toLowerCase()),
        );
      } else {
        this.classesFiltered = this.classes;
      }
    },
  },
  methods: {
    showCreateModal() {
      this.$store.dispatch('showAddClassModal');
    },
    classSelected(action) {
      switch (action.action) {
        case 'remove':
          this.$dialog
            .confirm('Please confirm to remove the class')
            .then(() => {
              this.$store.dispatch('removeClass', action.group.id).then(() => {
                this.$store.dispatch('getClasses');
              });
            })
            .catch(() => {});
          break;
        default:
          this.$store.dispatch('selectClass', action.group);
          this.$router.push('/student/select');
          break;
      }
    },
  },
  created() {
    this.$store.dispatch('getClasses');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/classes/ClassSelection.vue